import { useMutation } from 'query';
import { changePassword } from '../../services';

type ChangePasswordData = {
  currentPassword: string;
  password: string;
};

export const useChangePassword = () =>
  useMutation<unknown, ChangePasswordData>({
    async mutationFn({ currentPassword, password }) {
      const request = {
        body: {
          user: {
            /* eslint-disable @typescript-eslint/naming-convention -- Start: required by backend API */
            current_password: currentPassword,
            password,
            /* eslint-enable @typescript-eslint/naming-convention -- End: required by backend API */
          },
        },
      };

      return changePassword(request);
    },
  });
